import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Custom navigation hook that properly handles base paths for the application
 * This ensures consistent navigation regardless of whether the app is deployed at root
 * or in a subdirectory like /affiliate/
 * 
 * @returns {Function} The navigate function that automatically handles base paths
 */
const useAppNavigate = () => {
  const navigate = useNavigate();
  
  // Create a wrapped version of navigate that doesn't need basename considerations
  // React Router's useNavigate already handles the basename from BrowserRouter
  return useCallback((to, options) => {
    navigate(to, options);
  }, [navigate]);
};

export default useAppNavigate;
